import SpriteSymbol from "../../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "icon-leftalignment 451",
  "use": "icon-leftalignment 451-usage",
  "viewBox": "0 0 1024 1024",
  "content": "<symbol xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 1024 1024\" id=\"icon-leftalignment 451\"><path d=\"M810.666667 768v64H213.333333v-64h597.333334z m-341.333334-192v64H213.333333v-64h256z m170.666667-192v64H213.333333v-64h426.666667z m170.666667-192v64H213.333333V192h597.333334z\" p-id=\"28271\" /></symbol>"
});
var result = sprite.add(symbol);
export default symbol